import AppConfig from '../config/AppConfig';

export function getEnviormentUrls() {
    return {
        apiHost:    import.meta.env.REACT_APP_HOST || window.location.host,
        apiGetHost: import.meta.env.REACT_APP_GET_HOST || window.location.host,
        mediaHost:  import.meta.env.REACT_APP_MEDIA_HOST ,
    };
}

// Returns full path of asset
export function getPath(path) {
    let Config = new AppConfig();
    return (Config.debug_mode ? Config.media_path + path : path);
}

// Returns full path of asset
export function getMediaPath(path) {
    let Config = new AppConfig();
    return Config.media_path + path;
}

// Check for empty objects
export function notEmptyObject(obj) {
    let empty = true;

    if(obj) {
        if (Object.keys(obj).length !== 0 && obj.constructor === Object) {
            empty = false;
        }
    }

    return empty;
}

// Convert Object to sorted array by order_num
export function convertToSortedArray(obj) {
    let sortedArr = Object.keys(obj).map(key => obj[key]);
    sortedArr = sortedArr.sort((a,b) => { return a.order_num - b.order_num });
    return sortedArr;
}

// Query browser for user location
export function getUserGeoLocation(onSuccess, onFailure) {
    if ("geolocation" in navigator) {
        // Check if geolocation is supported/enabled on current browser
        navigator.geolocation.getCurrentPosition (
            function success(position) {
                // For when getting location is a success
                onSuccess(position);
            },
            function error(error_message) {
                // For when getting location results in an error
                onFailure(error_message);
            });
    } else {
        // Geolocation is not supported
        // Get your location some other way
        console.log('geolocation is not enabled on this browser');
    }
}

// Calculate distance in Km between 2 gps sets
export function calcDistance(p1, p2) {
    const toRad = (num) => num * Math.PI / 180;

    var R = 6371; // Radius of the earth in km
    var dLat = toRad((p1.lat - p2.lat)); // Javascript functions in radians
    var dLon = toRad((p1.lng - p2.lng));
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(p2.lat)) * Math.cos(toRad(p1.lat)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km

    return parseInt(d);
}

// Generate unique IDs
export function generateUniqueId(length = 16) {
    var result           = [];
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result.push(characters.charAt(Math.floor(Math.random() *
            charactersLength)));
    }
    return result.join('');
}

// Combine multiple class-names to a string, and ignore falsely items
export function combineClassNames(...classNames) {
    return classNames.filter(Boolean).join(' ');
}

// Remove the protocol (http/https) from a URL
export function removeProtocolFromUrl(urlString) {
    if (typeof urlString !== 'string') {
        return null;
    }

    return urlString.replace(/^https?:\/\//, '');
}
